{
  "id": "linkedin.com",
  "version": 3,
  "name": "LinkedIn",
  "author": "SR",
  "date": "2023-07-04",
  "url": "https://linkedin.com",
  "strings": {
    "en": {
      "name": "LinkedIn",
      "help": [
        "https://www.linkedin.com/psettings/member-data",
        "(Log in with your account)",
        "Select the first radio button - download a large archive",
        "Click Button download Archive'",
        "Wait for the email and follow the instructions (takes up to 24 hours usually)",
        "You will have to enter your password once again."
      ]
    },
    "de": {
      "name": "LinkedIn",
      "help": [
        "https://www.linkedin.com/psettings/member-data",
        "(Melde dich an)",
        "Wähle den ersten Punkt 'Größeres Datenarchiv herunterladen' aus.",
        "Klicke auf den Button 'Archive herunterladen'",
        "Warte auf die Bestätigungsmail (dauert etwa 24 Stunden).",
        "Du kannst danach über den Link deine personenbezogenen Daten runterladen.",
        "Dafür wirst du dein Passwort nochmal eingeben müssen."
      ]
    }
  },
  "instructions": [
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "School Name": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Start Date": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "End Date": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Notes": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Degree Name": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Activities": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Extension": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Number": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Type": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "savedItem": [
                      {
                        "type": "string"
                      }
                    ],
                    "createdTime": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "createdTime"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Event Name": [
                      {
                        "type": "string"
                      }
                    ],
                    "Event Time": [
                      {
                        "type": "string"
                      }
                    ],
                    "Status": [
                      {
                        "type": "string"
                      }
                    ],
                    "External Url": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "First Name": [
                      {
                        "type": "string"
                      }
                    ],
                    "Last Name": [
                      {
                        "type": "string"
                      }
                    ],
                    "Maiden Name": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Address": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Birth Date": [
                      {
                        "type": "string"
                      }
                    ],
                    "Headline": [
                      {
                        "type": "string"
                      }
                    ],
                    "Summary": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Industry": [
                      {
                        "type": "string"
                      }
                    ],
                    "Zip Code": [
                      {
                        "type": "string"
                      }
                    ],
                    "Geo Location": [
                      {
                        "type": "string"
                      }
                    ],
                    "Twitter Handles": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Websites": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Instant Messengers": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["labelDate"],
              "arguments": {
                "iso": true
              },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Company Name": [
                      {
                        "type": "string"
                      }
                    ],
                    "Title": [
                      {
                        "type": "string"
                      }
                    ],
                    "Description": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Location": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Started On": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "lang": "en"
                          }
                        }
                      }
                    ],
                    "Finished On": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["labelDate"],
              "arguments": {
                "iso": true
              },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Link": [
                      {
                        "type": "string"
                      }
                    ],
                    "Message": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Posts",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Date"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Ad clicked Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Ad Title/Id": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "factor": 1000
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Ad clicked Date"],
              "arguments": {
                "iso": true
              },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Notes:": [
                      {
                        "type": "string"
                      }
                    ],
                    "__parsed_extra": [
                      {
                        "type": "array",
                        "anyOf": [
                          {
                            "type": "string"
                          }
                        ]
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Contacts",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Time": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Search Query": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Time"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Type": [
                      {
                        "type": "string"
                      }
                    ],
                    "Link": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Likes",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            },
            {
              "type": "text",
              "value": ": "
            },
            {
              "type": "data",
              "value": ["data", null, null, "Type"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Date"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "From": [
                      {
                        "type": "string"
                      }
                    ],
                    "To": [
                      {
                        "type": "string"
                      }
                    ],
                    "Sent At": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Message": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Direction": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Sent At"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "��\"\u0000T\u0000i\u0000m\u0000e\u0000\"\u0000\t\u0000\"\u0000E\u0000v\u0000e\u0000n\u0000t\u0000\"\u0000": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Email Address": [
                      {
                        "type": "string"
                      }
                    ],
                    "Confirmed": [
                      {
                        "type": "string"
                      }
                    ],
                    "Primary": [
                      {
                        "type": "string"
                      }
                    ],
                    "Updated On": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Updated On"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Name": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Registered At": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Registration Ip": [
                      {
                        "type": "string"
                      }
                    ],
                    "Subscription Types": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Security",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Registered At"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Login Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "lang": "en"
                          }
                        }
                      }
                    ],
                    "IP Address": [
                      {
                        "type": "string"
                      }
                    ],
                    "User Agent": [
                      {
                        "type": "string"
                      }
                    ],
                    "Login Type": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Security",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Login Date"],
              "arguments": {
                "lang": "en"
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "CONVERSATION ID": [
                      {
                        "type": "string"
                      }
                    ],
                    "CONVERSATION TITLE": [
                      {
                        "type": "string"
                      }
                    ],
                    "FROM": [
                      {
                        "type": "string"
                      }
                    ],
                    "SENDER PROFILE URL": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "TO": [
                      {
                        "type": "string"
                      }
                    ],
                    "DATE": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "SUBJECT": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "CONTENT": [
                      {
                        "type": "string"
                      }
                    ],
                    "FOLDER": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Messages",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "DATE"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Organization": [
                      {
                        "type": "string"
                      }
                    ],
                    "Followed On": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "lang": "en"
                          }
                        }
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Contacts",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Followed On"],
              "arguments": {
                "lang": "en"
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "ShareLink": [
                      {
                        "type": "string"
                      }
                    ],
                    "ShareCommentary": [
                      {
                        "type": "string"
                      }
                    ],
                    "SharedURL": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "MediaURL": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Visibility": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Messages",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Date"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Category": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Type of inference": [
                      {
                        "type": "string"
                      }
                    ],
                    "Description": [
                      {
                        "type": "string"
                      }
                    ],
                    "Inference": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Account",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Member Age": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Names": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Names_1": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Follower of": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Names_2": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Category": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Company Size": [
                      {
                        "type": "string"
                      }
                    ],
                    "Degrees": [
                      {
                        "type": "string"
                      }
                    ],
                    "degreeClass": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Schools": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Growth Rate": [
                      {
                        "type": "string"
                      }
                    ],
                    "Fields of Study": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Connections": [
                      {
                        "type": "string"
                      }
                    ],
                    "Function By Size": [
                      {
                        "type": "string"
                      },
                      {
                        "type": "empty"
                      }
                    ],
                    "Job Functions": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Gender": [
                      {
                        "type": "string"
                      }
                    ],
                    "Graduation Year": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Groups": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Industries": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Interests": [
                      {
                        "type": "string"
                      }
                    ],
                    "Interface Locales": [
                      {
                        "type": "string"
                      }
                    ],
                    "interfaceLocale": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Traits": [
                      {
                        "type": "string"
                      }
                    ],
                    "Profile Locations": [
                      {
                        "type": "string"
                      }
                    ],
                    "Job Seniorities": [
                      {
                        "type": "string"
                      }
                    ],
                    "Member Skills": [
                      {
                        "type": "string"
                      }
                    ],
                    "Job Titles": [
                      {
                        "type": "string"
                      }
                    ],
                    "Job Titles_1": [
                      {
                        "type": "string"
                      }
                    ],
                    "Job Titles_2": [
                      {
                        "type": "string"
                      }
                    ],
                    "Years of Experience": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["labelDate"],
              "arguments": {
                "iso": true
              },
              "template": ["data", null]
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Saved Date": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "Job Url": [
                      {
                        "type": "string"
                      }
                    ],
                    "Job Title": [
                      {
                        "type": "string"
                      }
                    ],
                    "Company Name": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Activity",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "Saved Date"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "Description": [
                      {
                        "type": "string"
                      }
                    ],
                    "Link": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Media",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    },
    {
      "schema": [
        {
          "type": "array",
          "anyOf": [
            {
              "type": "array",
              "anyOf": [
                {
                  "type": "object",
                  "properties": {
                    "HashTag": [
                      {
                        "type": "string"
                      }
                    ],
                    "CreatedTime": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "LastModifiedTime": [
                      {
                        "type": "string",
                        "supposedUsage": {
                          "format": "time",
                          "argument": {
                            "iso": true
                          }
                        }
                      }
                    ],
                    "State": [
                      {
                        "type": "string"
                      }
                    ]
                  }
                }
              ]
            }
          ]
        }
      ],
      "templates": [
        {
          "path": ["data", null],
          "category": "Contacts",
          "subcategory": [
            {
              "type": "data",
              "value": ["labelFileName"]
            }
          ],
          "content": [
            {
              "type": "data",
              "value": ["data", null, null]
            }
          ],
          "selectedTimestamps": [
            {
              "path": ["data", null, null, "CreatedTime"],
              "arguments": {
                "iso": true
              }
            },
            {
              "path": ["data", null, null, "LastModifiedTime"],
              "arguments": {
                "iso": true
              }
            }
          ],
          "selectedUris": [],
          "selectedContacts": [],
          "selectedLatitudes": [],
          "selectedLongitudes": []
        }
      ],
      "hidden": false
    }
  ],
  "fileStructure": [
    "Education.csv",
    "PhoneNumbers.csv",
    "Saved_Items.csv",
    "Events.csv",
    "Profile.csv",
    "Positions.csv",
    "Comments.csv",
    "Ads Clicked.csv",
    "Connections.csv",
    "SearchQueries.csv",
    "Reactions.csv",
    "Rich Media.csv",
    "Invitations.csv",
    "Account Status History.csv",
    "Email Addresses.csv",
    "Skills.csv",
    "Registration.csv",
    "Logins.csv",
    "messages.csv",
    "Company Follows.csv",
    "Shares.csv",
    "Inferences_about_you.csv",
    "Ad_Targeting.csv",
    "Jobs/",
    "Videos.csv",
    "Hashtag_Follows.csv"
  ],
  "optionalFileStructure": []
}
